/**
 * Role mock data — 5 system roles (isSystem=true, locked) + 2 custom examples.
 * TODO: EXTENSION BEYOND SITEMAP v1.1 (requested by user, modeled after ancarat-bo).
 * System role alias dùng chung enum với StaffRole cũ để tương thích.
 */

export interface TenantRole {
  _id: string;
  name: string;
  alias: string;
  description?: string;
  permissionKeys: string[];
  isSystem: boolean;
  createdAt: string;
  updatedAt: string;
}

const now = new Date().toISOString();

export const SYSTEM_ROLE_IDS = {
  owner: 'role-sys-owner',
  manager: 'role-sys-manager',
  cashier: 'role-sys-cashier',
  inventory: 'role-sys-inventory',
  viewer: 'role-sys-viewer',
} as const;

export const mockRoles: TenantRole[] = [
  {
    _id: SYSTEM_ROLE_IDS.owner,
    name: 'Chủ tiệm',
    alias: 'owner',
    description: 'Quyền cao nhất — full access, billing, tenant settings.',
    permissionKeys: ['*'],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.manager,
    name: 'Quản lý',
    alias: 'manager',
    description: 'Quản lý chi nhánh — users, inventory, reports.',
    permissionKeys: [
      'pos.use',
      'pos.refund',
      'pos.buy_in',
      'pos.shifts_manage',
      'products.view',
      'products.create',
      'products.update',
      'products.delete',
      'products.print_label',
      'orders.view',
      'orders.cancel',
      'orders.print',
      'inventory.view',
      'inventory.stock_in',
      'inventory.stock_out',
      'inventory.adjust',
      'inventory.transfer',
      'reports.revenue',
      'reports.inventory',
      'staff.view',
      'staff.manage',
      'customers.view',
      'customers.manage',
      'settings.business',
      'settings.hardware',
      'settings.theme',
      'settings.profile',
      'settings.security',
      'settings.notifications',
      'settings.locale',
      'settings.payroll',
      'accounting.reports',
      'accounting.settings',
      'accounting.vouchers',
      'accounting.einvoice',
      'accounting.inventory',
      'accounting.ar',
      'gold_price.sources_manage',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.cashier,
    name: 'Thu ngân',
    alias: 'cashier',
    description: 'Bán hàng POS, xem đơn, không chỉnh kho / báo cáo.',
    permissionKeys: [
      'pos.use',
      'pos.refund',
      'pos.buy_in',
      'products.view',
      'orders.view',
      'orders.print',
      'customers.view',
      'customers.manage',
      'settings.profile',
      'settings.security',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.inventory,
    name: 'Thủ kho',
    alias: 'inventory',
    description: 'Quản lý tồn kho, nhập/xuất/kiểm kê/chuyển kho.',
    permissionKeys: [
      'products.view',
      'inventory.view',
      'inventory.stock_in',
      'inventory.stock_out',
      'inventory.adjust',
      'inventory.transfer',
      'settings.profile',
      'settings.security',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.viewer,
    name: 'Người xem',
    alias: 'viewer',
    description: 'Chỉ xem báo cáo doanh thu / tồn kho.',
    permissionKeys: [
      'reports.revenue',
      'reports.inventory',
      'customers.view',
      'settings.profile',
      'settings.security',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: 'role-custom-shift-lead',
    name: 'Trưởng ca',
    alias: 'shift_lead',
    description: 'Thu ngân cấp cao — bán + duyệt đổi trả + xem báo cáo doanh thu.',
    permissionKeys: [
      'pos.use',
      'pos.refund',
      'products.view',
      'orders.view',
      'orders.cancel',
      'orders.print',
      'reports.revenue',
    ],
    isSystem: false,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: 'role-custom-warehouse-supervisor',
    name: 'Giám sát kho',
    alias: 'warehouse_supervisor',
    description: 'Thủ kho cấp cao — có báo cáo tồn kho + quản lý nhân viên kho.',
    permissionKeys: [
      'products.view',
      'inventory.view',
      'inventory.stock_in',
      'inventory.stock_out',
      'inventory.adjust',
      'inventory.transfer',
      'reports.inventory',
      'staff.view',
    ],
    isSystem: false,
    createdAt: now,
    updatedAt: now,
  },
];

export function slugifyAlias(input: string): string {
  return input
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}
